/* eslint-disable camelcase */
export default class ProductMasterProcessStatus {
  constructor ({ description, status, error, updated_at }) {
    this.description = description
    this.status = status
    this.statusError = error
    this.updated_at = updated_at
  }

  get icon () {
    if (this.status === 'WORKING') return 'fa fa-spinner rotate-360'
    if (this.status === 'DONE') return 'fa fa-check-circle'
    if (this.status === 'DONE WITH WARNING') return 'fa fa-check-circle-o'
    if (this.status === 'ERROR') return 'fa fa-exclamation-circle'
    else return null
  }

  get error () {
    try {
      return JSON.parse(this.statusError)
    } catch (e) {
      return this.statusError
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/models/ProductMasterProcessStatus.js